import { render, staticRenderFns } from "./BuffersBSIM.vue?vue&type=template&id=111154ed&"
import script from "./BuffersBSIM.vue?vue&type=script&lang=js&"
export * from "./BuffersBSIM.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports